import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import SideBar from '../common/layout/sidebar.component.jsx';
import RoleEditForm from "./form/edit.component.jsx";

class RoleEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: {},
            userForm: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')

        const roleId = this.props.match.params.roleId
        AppContext.getApiClient().get('/roles/' + roleId).then(role => {
            this.setState({
                form: <RoleEditForm role={role} />
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default RoleEdit


// WEBPACK FOOTER //
// ./src/role/edit.component.jsx